import type { WelcomeStep } from "../types/WelcomeFlowTypes";

// The tour's centered intro; anchored steps load live from the Mapping View flow guide.
export const materialsMapNewUserSteps: WelcomeStep[] = [{ key: "materials-map-welcome", label: "Welcome", centered: true }];
